@if (!isSearchHidden) {
    <app-standard-search-box (searchTextChanged)="search($event)"></app-standard-search-box>
}
@if (visible$ | async) {
    <ngx-datatable
        #dataTable
        class="material striped expandable"
        [externalPaging]="externalPaging"
        [externalSorting]="externalSorting"
        [sorts]="sorts"
        [count]="totalItems"
        [offset]="pageNumber"
        [rows]="rows"
        [columns]="columns"
        [columnMode]="ColumnMode.force"
        [selectionType]="selectionType"
        [headerHeight]="45"
        [rowHeight]="34"
        [footerHeight]="50"
        [scrollbarV]="true"
        (selectedChange)="selectRow($event)"
        (page)="changePage($event)"
        (sort)="sort($event)"
        [messages]="{ emptyMessage: null, totalMessage: ('defaults.total' | translation | async), selectedMessage: '' }"
    >
        <!-- Row Detail Template -->
        <ngx-datatable-row-detail [rowHeight]="100">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                <div style="padding-left: 25px">
                    <ng-container *ngTemplateOutlet="expandableRowContent; context: row"></ng-container>
                </div>
            </ng-template>
        </ngx-datatable-row-detail>
        <!-- Column Templates -->
        <ng-template #expandableColumnTemplate let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <button class="btn" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" [title]="'defaults.displayDetails' | translation | async" (click)="toggleExpandRow(row)"></button>
        </ng-template>
    </ngx-datatable>
}

<!-- No records message -->
@if ((visible$ | async) === false) {
    <div class="vertical-centering">
        @if (noRecordsMessageAsString) {
            <div class="default-icon-color">
                <i class="fas fa-info-circle fa-7x"></i>
                <div class="no-records-message" [innerHTML]="noRecordsMessageAsString"></div>
            </div>
        }
        @if (noRecordsMessageAsTemplate) {
            <ng-template [ngTemplateOutlet]="noRecordsMessageAsTemplate"></ng-template>
        }
    </div>
}
